import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerHome = styled.div`
  width: 100%;
  height: 100vh;
`;

export const TextHome = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 20%;
  .title-saludo {
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-negrita {
    font-weight: bold;
  }
`;

export const BtnContainer = styled(motion.div)`
  width: 99%;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  svg {
    width: 25px;
    height: 25px;
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: var(--color-scrollbar);
  }

  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }
`;

export const HeaderHomeBar = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 95px;
  min-height: 95px;
  margin: 0;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);
  flex-shrink: 0;
  padding: 8px 15px;

  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  .title-pregunta {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  ::after {
    content: "";
    position: absolute;
    width: 100%;
    left: 0;
    height: 20px;
    bottom: -8px;
    z-index: 10;
    border-radius: 50%;
    background-color: var(--color-latex10);
  }
`;

export const ContianerHome = styled.div`
  width: 100vw;
  /* Altura = viewport - header (75px en mobile) */
  height: calc(100vh - 75px); /* fallback para navegadores antiguos */
  height: calc(100dvh - 75px); /* dvh descuenta la barra del navegador móvil */
  background-color: transparent;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .redirection {
    position: absolute;
    height: max-content;
    width: max-content;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding-bottom: 20px;
    @media (max-height: 780px) {
      padding-bottom: 0px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: -1;
    }
  }

  .logo-dim {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -2;
  }

  .selected {
    background-color: red;
  }

  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }
`;
